<script>
export default {
  props: {
    icon: {
      type: String,
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['calender', 'language', 'pubType'].includes(value)
      },
      default: 'calender'
    }
  },
  data() {
    return {

    }
  },
  computed: {
    tagIcon() {
      return require(`../assets/img/icon_${this.icon}.png`);
    }
  }
}
</script>
<template>
  <div class="articleTag">
    <img class="icon" :src="tagIcon" />
    <span class="text"><slot></slot></span>
  </div>
</template>
<style scoped>
  .articleTag {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    background: rgba(52, 145, 250, 0.1);
    border-radius: 2px;
  }
  .articleTag + .articleTag {
    margin-left: 10px;
  }
  .articleTag .icon {
    width: 12px;
    height: 12px;
    margin-right: 3px;
    vertical-align: middle;
  }
  .articleTag .text {
    color: #3491FA;
    font-size: 14px;
  }
</style>


// WEBPACK FOOTER //
// src/components/articleTag.vue